
import { Theme } from '@mui/material/styles';
import { withStyles } from 'tss-react/mui';
import EDIcon from '../../../../../../../../../../BaseComponents/Icon/EDIcon';
import EDButton from '../../../../../../../../../../BaseComponents/Buttons/Button/EDButton';

interface IProps {
  onClearSelected: () => void;
  classes?: any;
}

const Styles = (theme: Theme) => ({
  root: {
    marginTop: '-12px',
    display: 'flex',
    alignItems: 'center',
  },
});

const EkonomiskAnalysSummeringToolbar = (props: IProps) => {
  return (
    <div className={props.classes.root}>
      <EDButton
        color="inherit"
        label="Rensa allt"
        onClick={props.onClearSelected}
        icon={<EDIcon color="inherit" iconType="clear_all" />}
        flat
        captionLabel
        labelNotUpperCase
      />
      <EDButton
        color="inherit"
        label="Öppna mall"
        onClick={() => {}}
        icon={<EDIcon color="inherit" iconType="folder_open" />}
        flat
        captionLabel
        labelNotUpperCase
      />
      <EDButton
        color="inherit"
        label="Välj favorit"
        onClick={() => {}}
        icon={<EDIcon color="inherit" iconType="star_border" />}
        flat
        captionLabel
        labelNotUpperCase
      />
    </div>
  );
};

export default withStyles(EkonomiskAnalysSummeringToolbar, Styles);
